import React from 'react';
import {
  Paper, Box, Typography, Accordion, AccordionSummary, AccordionDetails,
  Chip, Stack, IconButton, Tooltip
} from '@mui/material';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import { DateTime } from 'luxon';

const ContactIcons = ({ email, phone, t }) => {
  const hasEmail = !!email;
  const hasPhone = !!phone && phone !== "-";
    const handleWhatsApp = (mobile) => {
    const cleanNumber = mobile.replace(/\D/g, '');
      window.open(`https://wa.me/${cleanNumber}`, '_blank');
    };
  if (!hasEmail && !hasPhone) return null;

  return (
    <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
      {hasEmail && (
        <Tooltip title={t("Invia Email")}>
          <IconButton
            size="small"
            color="primary"
            onClick={() => window.location.href = `mailto:${email}`}
          >
            <EmailIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      {hasPhone && (
        <>
          <Tooltip title={t("Chiama")}>
            <IconButton
              size="small"
              color="success"
              onClick={() => window.location.href = `tel:${phone}`}
            >
              <PhoneIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title={t("WhatsApp")}>
            <IconButton
              size="small"
              sx={{ color: '#25D366' }}
              onClick={() => handleWhatsApp(phone)}
            >
              <WhatsAppIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </>
      )}
    </Stack>
  );
};

const NewsWidget = ({ boardData, t , loading}) => {
  if (!loading && boardData.length === 0) return null;
  return (
    <Paper 
      id="home-news" 
      elevation={0}
      sx={{ 
        mb: 3, mx: 0, width: '100%', 
        overflow: 'hidden', 
        borderRadius: '16px',
        border: '1px solid #e2e8f0', 
        bgcolor: '#f8fafc' 
      }}
    >
      {/* HEADER UNIFORMATO */}
      <Box sx={{ 
        bgcolor: '#fff', 
        p: 2, 
        borderBottom: '1px solid #f0f4f8',
        display: 'flex',
        alignItems: 'center'
      }}>
        <Typography 
          variant="h6" 
          sx={{ 
            color: '#1a365d',
            fontWeight: 800, 
            fontSize: '1.1rem',
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            textTransform: 'uppercase',
            letterSpacing: 1
          }}
        >
          <AnnouncementIcon />
          {t("news")}
        </Typography>
      </Box>
      
      <Box sx={{ p: 2 }}>
        {boardData.map((item, idx) => {
          let dM = new Date(item.createdAt);
          const formattedDate = DateTime.fromJSDate(dM).toFormat("dd/MM/yyyy");
          
          return (
            <Accordion 
              key={idx} 
              elevation={0}
              disableGutters
              sx={{ 
                mb: 1.5, 
                borderRadius: '12px !important',
                border: '1px solid #edf2f7',
                bgcolor: '#fff',
                '&:before': { display: 'none' },
                overflow: 'hidden'
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: '#1a365d' }} />}
                sx={{ 
                  px: 2,
                  '&.Mui-expanded': { borderBottom: '1px solid #f0f4f8' }
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                  <Typography variant="body2" sx={{ fontWeight: 700, color: '#2d3748', flex: 1 }}>
                    {item.subject}
                  </Typography>
                  <Chip
                    label={formattedDate}
                    size="small"
                    variant="filled"
                    sx={{ 
                      fontSize: '0.7rem', 
                      fontWeight: 800,
                      bgcolor: '#e2e8f0', 
                      color: '#4a5568',
                      borderRadius: '6px'
                    }}
                  />
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{ bgcolor: 'white', p: 2 }}>
                <Typography 
                  variant="body2" 
                  sx={{ color: '#4a5568', lineHeight: 1.7 }}
                  dangerouslySetInnerHTML={{
                    __html: item.main.replace(/(?:\r\n|\r|\n)/g, "<br>")
                  }}
                />
                {item.msgType === "sportivi" && (
                  <ContactIcons email={item.email} phone={item.phone} t={t} />
                )}
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>
    </Paper>
  );
};

export default NewsWidget;